import { render, staticRenderFns } from "./Oushi.vue?vue&type=template&id=87aa985c&scoped=true&"
import script from "./Oushi.vue?vue&type=script&lang=js&"
export * from "./Oushi.vue?vue&type=script&lang=js&"
import style0 from "./Oushi.vue?vue&type=style&index=0&id=87aa985c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87aa985c",
  null
  
)

export default component.exports